//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AnalyzeFileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    analyzeFilterAndSheets(model: AnalyzeFilePostModel, cancelToken?: CancelToken): Promise<AnalyzeFilterAndSheetsResultModel> {
        let url_ = this.baseUrl + "/api/analyze-file/filter-and-sheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalyzeFilterAndSheets(_response);
        });
    }

    protected processAnalyzeFilterAndSheets(response: AxiosResponse): Promise<AnalyzeFilterAndSheetsResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnalyzeFilterAndSheetsResultModel.fromJS(resultData200);
            return Promise.resolve<AnalyzeFilterAndSheetsResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalyzeFilterAndSheetsResultModel>(null as any);
    }

    analyzeParameters(model: AnalyzeParametersPostModel, cancelToken?: CancelToken): Promise<AnalyzeParametersResultModel> {
        let url_ = this.baseUrl + "/api/analyze-file/parameters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnalyzeParameters(_response);
        });
    }

    protected processAnalyzeParameters(response: AxiosResponse): Promise<AnalyzeParametersResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AnalyzeParametersResultModel.fromJS(resultData200);
            return Promise.resolve<AnalyzeParametersResultModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalyzeParametersResultModel>(null as any);
    }
}

export class DispatcherCallbacksClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    success(model: CalculationCompletedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/success";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuccess(_response);
        });
    }

    protected processSuccess(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    error(model: CalculationFailedCallbackModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/dispatcher-callback/error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processError(_response);
        });
    }

    protected processError(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ExperimentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    getExperimentIdsByFilterId(filterId: number, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/experiments/by-filter-Id/{filterId}";
        if (filterId === undefined || filterId === null)
            throw new Error("The parameter 'filterId' must be defined.");
        url_ = url_.replace("{filterId}", encodeURIComponent("" + filterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExperimentIdsByFilterId(_response);
        });
    }

    protected processGetExperimentIdsByFilterId(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    createExperiment(model: DoeExperimentPostModel, cancelToken?: CancelToken): Promise<ScenarioResultModel> {
        let url_ = this.baseUrl + "/api/experiments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExperiment(_response);
        });
    }

    protected processCreateExperiment(response: AxiosResponse): Promise<ScenarioResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioResultModel>(null as any);
    }

    updateExperiment(experimentId: number, model: DoeExperimentPostModel, cancelToken?: CancelToken): Promise<ScenarioResultModel> {
        let url_ = this.baseUrl + "/api/experiments/{experimentId}/update";
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExperiment(_response);
        });
    }

    protected processUpdateExperiment(response: AxiosResponse): Promise<ScenarioResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioResultModel>(null as any);
    }

    addExperimentDataRows(experimentId: number, model: AddExperimentDataRowsPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/experiments/{experimentId}/add-data-rows";
        if (experimentId === undefined || experimentId === null)
            throw new Error("The parameter 'experimentId' must be defined.");
        url_ = url_.replace("{experimentId}", encodeURIComponent("" + experimentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddExperimentDataRows(_response);
        });
    }

    protected processAddExperimentDataRows(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cloneSharedExperiment(model: CloneSharedDoeExperimentPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/experiments/clone-shared";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneSharedExperiment(_response);
        });
    }

    protected processCloneSharedExperiment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cloneExperiments(model: CloneExperimentsPostModel, cancelToken?: CancelToken): Promise<CloneExperimentResponseModel> {
        let url_ = this.baseUrl + "/api/experiments/clone-multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneExperiments(_response);
        });
    }

    protected processCloneExperiments(response: AxiosResponse): Promise<CloneExperimentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloneExperimentResponseModel.fromJS(resultData200);
            return Promise.resolve<CloneExperimentResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloneExperimentResponseModel>(null as any);
    }
}

export class ExportDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    generateExcel(model: GenerateExcelRequestModel, cancelToken?: CancelToken): Promise<GenerateExcelResponseModel> {
        let url_ = this.baseUrl + "/api/export-data/excel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateExcel(_response);
        });
    }

    protected processGenerateExcel(response: AxiosResponse): Promise<GenerateExcelResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateExcelResponseModel.fromJS(resultData200);
            return Promise.resolve<GenerateExcelResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateExcelResponseModel>(null as any);
    }

    getStatus(requestId: string, cancelToken?: CancelToken): Promise<ExportDataStatus> {
        let url_ = this.baseUrl + "/api/export-data/status/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<ExportDataStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportDataStatus.fromJS(resultData200);
            return Promise.resolve<ExportDataStatus>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportDataStatus>(null as any);
    }
}

export class ScenarioCountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    getExcelScenarioCount(model: ScenarioCountPostModel, cancelToken?: CancelToken): Promise<ScenarioCountResultModel[]> {
        let url_ = this.baseUrl + "/api/scenario-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExcelScenarioCount(_response);
        });
    }

    protected processGetExcelScenarioCount(response: AxiosResponse): Promise<ScenarioCountResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScenarioCountResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScenarioCountResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioCountResultModel[]>(null as any);
    }
}

export class ScenarioProcessingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    startProcessing(model: ScenarioProcessingQuery, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenario-processing/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartProcessing(_response);
        });
    }

    protected processStartProcessing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResultModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    stopProcessing(model: ScenarioProcessingQuery, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenario-processing/stop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopProcessing(_response);
        });
    }

    protected processStopProcessing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResultModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resumeProcessing(model: ScenarioProcessingQuery, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenario-processing/resume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResumeProcessing(_response);
        });
    }

    protected processResumeProcessing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResultModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resubmitFailedRows(model: ResubmitFailedJobsPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenario-processing/resubmit-failed-rows";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmitFailedRows(_response);
        });
    }

    protected processResubmitFailedRows(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ScenariosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    getScenarios(query: ScenariosListQuery, cancelToken?: CancelToken): Promise<ScenarioResultModel[]> {
        let url_ = this.baseUrl + "/api/scenarios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenarios(_response);
        });
    }

    protected processGetScenarios(response: AxiosResponse): Promise<ScenarioResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScenarioResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ScenarioResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioResultModel[]>(null as any);
    }

    getAllUserScenarios(skip: number | undefined, take: number | undefined, orderByIdDesc: boolean | undefined, cancelToken?: CancelToken): Promise<ScenarioListResponseModel> {
        let url_ = this.baseUrl + "/api/scenarios/all-user-scenarios?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (orderByIdDesc === null)
            throw new Error("The parameter 'orderByIdDesc' cannot be null.");
        else if (orderByIdDesc !== undefined)
            url_ += "OrderByIdDesc=" + encodeURIComponent("" + orderByIdDesc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUserScenarios(_response);
        });
    }

    protected processGetAllUserScenarios(response: AxiosResponse): Promise<ScenarioListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioListResponseModel.fromJS(resultData200);
            return Promise.resolve<ScenarioListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioListResponseModel>(null as any);
    }

    getScenario(query: ScenarioQuery, cancelToken?: CancelToken): Promise<ScenarioResultModel> {
        let url_ = this.baseUrl + "/api/scenarios/get-single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenario(_response);
        });
    }

    protected processGetScenario(response: AxiosResponse): Promise<ScenarioResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioResultModel>(null as any);
    }

    getScenarioById(scenarioId: number, cancelToken?: CancelToken): Promise<ScenarioResultModel> {
        let url_ = this.baseUrl + "/api/scenarios/by-id/{scenarioId}";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenarioById(_response);
        });
    }

    protected processGetScenarioById(response: AxiosResponse): Promise<ScenarioResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioResultModel>(null as any);
    }

    reloadDataFromFile(scenarioId: number, cancelToken?: CancelToken): Promise<ReloadDataFromFileResultModel> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/reload-data-from-file";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReloadDataFromFile(_response);
        });
    }

    protected processReloadDataFromFile(response: AxiosResponse): Promise<ReloadDataFromFileResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReloadDataFromFileResultModel.fromJS(resultData200);
            return Promise.resolve<ReloadDataFromFileResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReloadDataFromFileResultModel>(null as any);
    }

    saveScenario(model: ScenarioPostModel, cancelToken?: CancelToken): Promise<ScenarioResultModel> {
        let url_ = this.baseUrl + "/api/scenarios/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveScenario(_response);
        });
    }

    protected processSaveScenario(response: AxiosResponse): Promise<ScenarioResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioResultModel>(null as any);
    }

    getScenarioData(query: ScenarioDataQuery, cancelToken?: CancelToken): Promise<ScenarioDataResultModel> {
        let url_ = this.baseUrl + "/api/scenarios/data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenarioData(_response);
        });
    }

    protected processGetScenarioData(response: AxiosResponse): Promise<ScenarioDataResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioDataResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioDataResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioDataResultModel>(null as any);
    }

    getScenarioDataElastic(userQuery: SenarioDataElasticQuery, cancelToken?: CancelToken): Promise<ScenarioDataResultModel> {
        let url_ = this.baseUrl + "/api/scenarios/data-elastic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenarioDataElastic(_response);
        });
    }

    protected processGetScenarioDataElastic(response: AxiosResponse): Promise<ScenarioDataResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioDataResultModel.fromJS(resultData200);
            return Promise.resolve<ScenarioDataResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioDataResultModel>(null as any);
    }

    deleteScenario(model: DeleteScenarioPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScenario(_response);
        });
    }

    protected processDeleteScenario(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    restoreScenario(scenarioId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/restore";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreScenario(_response);
        });
    }

    protected processRestoreScenario(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    writeResults(model: ScenarioWriteResultsQuery, cancelToken?: CancelToken): Promise<WriteResultsResponseModel> {
        let url_ = this.baseUrl + "/api/scenarios/write-results";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteResults(_response);
        });
    }

    protected processWriteResults(response: AxiosResponse): Promise<WriteResultsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WriteResultsResponseModel.fromJS(resultData200);
            return Promise.resolve<WriteResultsResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WriteResultsResponseModel>(null as any);
    }

    getReloadDataStatus(requestId: string, cancelToken?: CancelToken): Promise<UpdateDataFromFileStatusModel> {
        let url_ = this.baseUrl + "/api/scenario/reload-data/{requestId}/status";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReloadDataStatus(_response);
        });
    }

    protected processGetReloadDataStatus(response: AxiosResponse): Promise<UpdateDataFromFileStatusModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateDataFromFileStatusModel.fromJS(resultData200);
            return Promise.resolve<UpdateDataFromFileStatusModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateDataFromFileStatusModel>(null as any);
    }

    getWriteResultsStatus(requestId: string, cancelToken?: CancelToken): Promise<WriteResultsStatusModel> {
        let url_ = this.baseUrl + "/api/scenario/write-results/{requestId}/status";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWriteResultsStatus(_response);
        });
    }

    protected processGetWriteResultsStatus(response: AxiosResponse): Promise<WriteResultsStatusModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WriteResultsStatusModel.fromJS(resultData200);
            return Promise.resolve<WriteResultsStatusModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WriteResultsStatusModel>(null as any);
    }

    resubmitRow(model: ResubmitRowPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/resubmit-row";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResubmitRow(_response);
        });
    }

    protected processResubmitRow(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    reindexDetectionsInElasticsearch( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindexDetectionsInElasticsearch(_response);
        });
    }

    protected processReindexDetectionsInElasticsearch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getReindexRequests( cancelToken?: CancelToken): Promise<ReindexingRunModel[]> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex-requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReindexRequests(_response);
        });
    }

    protected processGetReindexRequests(response: AxiosResponse): Promise<ReindexingRunModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReindexingRunModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReindexingRunModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReindexingRunModel[]>(null as any);
    }

    getReindexRequest(requestId: string, cancelToken?: CancelToken): Promise<ReindexingRunModel> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex-requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReindexRequest(_response);
        });
    }

    protected processGetReindexRequest(response: AxiosResponse): Promise<ReindexingRunModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReindexingRunModel.fromJS(resultData200);
            return Promise.resolve<ReindexingRunModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReindexingRunModel>(null as any);
    }
}

export class ServiceInformationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:9481";

    }

    getBuildDate( cancelToken?: CancelToken): Promise<ServiceInformationModel> {
        let url_ = this.baseUrl + "/api/serviceInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildDate(_response);
        });
    }

    protected processGetBuildDate(response: AxiosResponse): Promise<ServiceInformationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceInformationModel.fromJS(resultData200);
            return Promise.resolve<ServiceInformationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceInformationModel>(null as any);
    }
}

export class AnalyzeFilterAndSheetsResultModel implements IAnalyzeFilterAndSheetsResultModel {
    sheets?: string[] | undefined;

    constructor(data?: IAnalyzeFilterAndSheetsResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sheets"])) {
                this.sheets = [] as any;
                for (let item of _data["sheets"])
                    this.sheets!.push(item);
            }
        }
    }

    static fromJS(data: any): AnalyzeFilterAndSheetsResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeFilterAndSheetsResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sheets)) {
            data["sheets"] = [];
            for (let item of this.sheets)
                data["sheets"].push(item);
        }
        return data;
    }
}

export interface IAnalyzeFilterAndSheetsResultModel {
    sheets?: string[] | undefined;
}

export class AnalyzeFilePostModel implements IAnalyzeFilePostModel {
    driveId!: string;
    fileId!: string;
    accessToken!: string;

    constructor(data?: IAnalyzeFilePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driveId = _data["driveId"];
            this.fileId = _data["fileId"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): AnalyzeFilePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeFilePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveId"] = this.driveId;
        data["fileId"] = this.fileId;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IAnalyzeFilePostModel {
    driveId: string;
    fileId: string;
    accessToken: string;
}

export class AnalyzeParametersResultModel implements IAnalyzeParametersResultModel {
    firstRow!: number;
    inputParameters?: ParameterModel[] | undefined;
    outputParameters?: ParameterModel[] | undefined;

    constructor(data?: IAnalyzeParametersResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstRow = _data["firstRow"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(ParameterModel.fromJS(item));
            }
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(ParameterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalyzeParametersResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeParametersResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstRow"] = this.firstRow;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalyzeParametersResultModel {
    firstRow: number;
    inputParameters?: ParameterModel[] | undefined;
    outputParameters?: ParameterModel[] | undefined;
}

export class ParameterModel implements IParameterModel {
    filterParameterId!: number;
    column?: string | undefined;

    constructor(data?: IParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterParameterId = _data["filterParameterId"];
            this.column = _data["column"];
        }
    }

    static fromJS(data: any): ParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterParameterId"] = this.filterParameterId;
        data["column"] = this.column;
        return data;
    }
}

export interface IParameterModel {
    filterParameterId: number;
    column?: string | undefined;
}

export class ErrorResultModel implements IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class AnalyzeParametersPostModel extends AnalyzeFilePostModel implements IAnalyzeParametersPostModel {
    filterId!: number;
    sheet?: string | undefined;

    constructor(data?: IAnalyzeParametersPostModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filterId = _data["filterId"];
            this.sheet = _data["sheet"];
        }
    }

    static fromJS(data: any): AnalyzeParametersPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeParametersPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        data["sheet"] = this.sheet;
        super.toJSON(data);
        return data;
    }
}

export interface IAnalyzeParametersPostModel extends IAnalyzeFilePostModel {
    filterId: number;
    sheet?: string | undefined;
}

export class CallbackModelBase implements ICallbackModelBase {
    jobId!: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;

    constructor(data?: ICallbackModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.flowsheetItemId = _data["flowsheetItemId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
        }
    }

    static fromJS(data: any): CallbackModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["flowsheetItemId"] = this.flowsheetItemId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        return data;
    }
}

export interface ICallbackModelBase {
    jobId: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
}

export class CalculationCompletedCallbackModel extends CallbackModelBase implements ICalculationCompletedCallbackModel {
    simulator!: SimulatorType;
    outputParameters?: OutputParameterCallbackModel[] | undefined;

    constructor(data?: ICalculationCompletedCallbackModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.simulator = _data["simulator"];
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterCallbackModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationCompletedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCompletedCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simulator"] = this.simulator;
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationCompletedCallbackModel extends ICallbackModelBase {
    simulator: SimulatorType;
    outputParameters?: OutputParameterCallbackModel[] | undefined;
}

export enum SimulatorType {
    Chemcad7 = 1,
    DWSIM = 2,
    Chemcad8 = 3,
}

export class OutputParameterCallbackModel implements IOutputParameterCallbackModel {
    parameter?: string | undefined;
    value!: number;

    constructor(data?: IOutputParameterCallbackModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OutputParameterCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IOutputParameterCallbackModel {
    parameter?: string | undefined;
    value: number;
}

export class CalculationFailedCallbackModel extends CallbackModelBase implements ICalculationFailedCallbackModel {
    errorMessage?: string | undefined;

    constructor(data?: ICalculationFailedCallbackModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): CalculationFailedCallbackModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationFailedCallbackModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        super.toJSON(data);
        return data;
    }
}

export interface ICalculationFailedCallbackModel extends ICallbackModelBase {
    errorMessage?: string | undefined;
}

export class ScenarioResultModel implements IScenarioResultModel {
    id!: number;
    name?: string | undefined;
    sheet?: string | undefined;
    analysisStatus!: AnalysisStatus;
    analysisMessage?: string | undefined;
    processingStatus!: ProcessingStatus;
    calculationType!: CalculationType;
    firstRow!: number;
    saveResultsToSourceFile!: boolean;
    stepEvaluationFunction?: string | undefined;
    totalRows!: number;
    calculatedRows!: number;
    failedRows!: number;
    fileDriveId?: string | undefined;
    fileVersion?: string | undefined;
    filterId!: number;
    filterVersionId!: number;
    createdAt!: Date;
    resultsSavingMessage?: string | undefined;
    flowsheetUniqueId?: string | undefined;
    inputParameters?: InputParameterResultModel[] | undefined;
    outputParameters?: OutputParameterResultModel[] | undefined;
    isDeleted!: boolean;

    constructor(data?: IScenarioResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sheet = _data["sheet"];
            this.analysisStatus = _data["analysisStatus"];
            this.analysisMessage = _data["analysisMessage"];
            this.processingStatus = _data["processingStatus"];
            this.calculationType = _data["calculationType"];
            this.firstRow = _data["firstRow"];
            this.saveResultsToSourceFile = _data["saveResultsToSourceFile"];
            this.stepEvaluationFunction = _data["stepEvaluationFunction"];
            this.totalRows = _data["totalRows"];
            this.calculatedRows = _data["calculatedRows"];
            this.failedRows = _data["failedRows"];
            this.fileDriveId = _data["fileDriveId"];
            this.fileVersion = _data["fileVersion"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.resultsSavingMessage = _data["resultsSavingMessage"];
            this.flowsheetUniqueId = _data["flowsheetUniqueId"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(InputParameterResultModel.fromJS(item));
            }
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterResultModel.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ScenarioResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sheet"] = this.sheet;
        data["analysisStatus"] = this.analysisStatus;
        data["analysisMessage"] = this.analysisMessage;
        data["processingStatus"] = this.processingStatus;
        data["calculationType"] = this.calculationType;
        data["firstRow"] = this.firstRow;
        data["saveResultsToSourceFile"] = this.saveResultsToSourceFile;
        data["stepEvaluationFunction"] = this.stepEvaluationFunction;
        data["totalRows"] = this.totalRows;
        data["calculatedRows"] = this.calculatedRows;
        data["failedRows"] = this.failedRows;
        data["fileDriveId"] = this.fileDriveId;
        data["fileVersion"] = this.fileVersion;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["resultsSavingMessage"] = this.resultsSavingMessage;
        data["flowsheetUniqueId"] = this.flowsheetUniqueId;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IScenarioResultModel {
    id: number;
    name?: string | undefined;
    sheet?: string | undefined;
    analysisStatus: AnalysisStatus;
    analysisMessage?: string | undefined;
    processingStatus: ProcessingStatus;
    calculationType: CalculationType;
    firstRow: number;
    saveResultsToSourceFile: boolean;
    stepEvaluationFunction?: string | undefined;
    totalRows: number;
    calculatedRows: number;
    failedRows: number;
    fileDriveId?: string | undefined;
    fileVersion?: string | undefined;
    filterId: number;
    filterVersionId: number;
    createdAt: Date;
    resultsSavingMessage?: string | undefined;
    flowsheetUniqueId?: string | undefined;
    inputParameters?: InputParameterResultModel[] | undefined;
    outputParameters?: OutputParameterResultModel[] | undefined;
    isDeleted: boolean;
}

export enum AnalysisStatus {
    NotAnalyzed = 0,
    AnalyzedSuccessfuly = 1,
    AnalysisFailed = 2,
}

export enum ProcessingStatus {
    NotRunning = 0,
    Running = 1,
    Finished = 2,
    Stopped = 3,
}

export enum CalculationType {
    RunAll = 1,
    StepByStep = 2,
}

export class InputParameterResultModel implements IInputParameterResultModel {
    id!: number;
    filterParameter?: string | undefined;
    filterParameterId!: number;
    column?: string | undefined;

    constructor(data?: IInputParameterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterParameter = _data["filterParameter"];
            this.filterParameterId = _data["filterParameterId"];
            this.column = _data["column"];
        }
    }

    static fromJS(data: any): InputParameterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new InputParameterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterParameter"] = this.filterParameter;
        data["filterParameterId"] = this.filterParameterId;
        data["column"] = this.column;
        return data;
    }
}

export interface IInputParameterResultModel {
    id: number;
    filterParameter?: string | undefined;
    filterParameterId: number;
    column?: string | undefined;
}

export class OutputParameterResultModel implements IOutputParameterResultModel {
    id!: number;
    filterParameter?: string | undefined;
    filterParameterId!: number;
    column?: string | undefined;

    constructor(data?: IOutputParameterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterParameter = _data["filterParameter"];
            this.filterParameterId = _data["filterParameterId"];
            this.column = _data["column"];
        }
    }

    static fromJS(data: any): OutputParameterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterParameter"] = this.filterParameter;
        data["filterParameterId"] = this.filterParameterId;
        data["column"] = this.column;
        return data;
    }
}

export interface IOutputParameterResultModel {
    id: number;
    filterParameter?: string | undefined;
    filterParameterId: number;
    column?: string | undefined;
}

export class DoeExperimentPostModel implements IDoeExperimentPostModel {
    name!: string;
    filterId!: number;
    filterVersionId!: number;
    flowsheetUniqueId!: string;
    inputDataRows?: ExperimentRowModel[] | undefined;

    constructor(data?: IDoeExperimentPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.flowsheetUniqueId = _data["flowsheetUniqueId"];
            if (Array.isArray(_data["inputDataRows"])) {
                this.inputDataRows = [] as any;
                for (let item of _data["inputDataRows"])
                    this.inputDataRows!.push(ExperimentRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DoeExperimentPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DoeExperimentPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["flowsheetUniqueId"] = this.flowsheetUniqueId;
        if (Array.isArray(this.inputDataRows)) {
            data["inputDataRows"] = [];
            for (let item of this.inputDataRows)
                data["inputDataRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDoeExperimentPostModel {
    name: string;
    filterId: number;
    filterVersionId: number;
    flowsheetUniqueId: string;
    inputDataRows?: ExperimentRowModel[] | undefined;
}

export class ExperimentRowModel implements IExperimentRowModel {
    parameters?: ExperimentParameterPostModel[] | undefined;

    constructor(data?: IExperimentRowModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ExperimentParameterPostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExperimentRowModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentRowModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExperimentRowModel {
    parameters?: ExperimentParameterPostModel[] | undefined;
}

export class ExperimentParameterPostModel implements IExperimentParameterPostModel {
    filterParameterId!: number;
    value!: number;

    constructor(data?: IExperimentParameterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterParameterId = _data["filterParameterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExperimentParameterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExperimentParameterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterParameterId"] = this.filterParameterId;
        data["value"] = this.value;
        return data;
    }
}

export interface IExperimentParameterPostModel {
    filterParameterId: number;
    value: number;
}

export class AddExperimentDataRowsPostModel implements IAddExperimentDataRowsPostModel {
    inputDataRows?: ExperimentRowModel[] | undefined;

    constructor(data?: IAddExperimentDataRowsPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inputDataRows"])) {
                this.inputDataRows = [] as any;
                for (let item of _data["inputDataRows"])
                    this.inputDataRows!.push(ExperimentRowModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddExperimentDataRowsPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddExperimentDataRowsPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inputDataRows)) {
            data["inputDataRows"] = [];
            for (let item of this.inputDataRows)
                data["inputDataRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddExperimentDataRowsPostModel {
    inputDataRows?: ExperimentRowModel[] | undefined;
}

export class CloneSharedDoeExperimentPostModel implements ICloneSharedDoeExperimentPostModel {
    experimentId!: number;
    filename!: string;
    destinationUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;

    constructor(data?: ICloneSharedDoeExperimentPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.filename = _data["filename"];
            this.destinationUniqueId = _data["destinationUniqueId"];
            this.conflictAction = _data["conflictAction"];
        }
    }

    static fromJS(data: any): CloneSharedDoeExperimentPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneSharedDoeExperimentPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["filename"] = this.filename;
        data["destinationUniqueId"] = this.destinationUniqueId;
        data["conflictAction"] = this.conflictAction;
        return data;
    }
}

export interface ICloneSharedDoeExperimentPostModel {
    experimentId: number;
    filename: string;
    destinationUniqueId?: string | undefined;
    conflictAction?: UploadConflictAction | undefined;
}

export enum UploadConflictAction {
    Overwrite = 0,
    KeepBoth = 1,
}

export class CloneExperimentResponseModel implements ICloneExperimentResponseModel {
    errors?: string[] | undefined;

    constructor(data?: ICloneExperimentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): CloneExperimentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneExperimentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ICloneExperimentResponseModel {
    errors?: string[] | undefined;
}

export class CloneExperimentsPostModel implements ICloneExperimentsPostModel {
    fileUniqueId!: string;
    experiments?: CloneExperimentModel[] | undefined;

    constructor(data?: ICloneExperimentsPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUniqueId = _data["fileUniqueId"];
            if (Array.isArray(_data["experiments"])) {
                this.experiments = [] as any;
                for (let item of _data["experiments"])
                    this.experiments!.push(CloneExperimentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CloneExperimentsPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneExperimentsPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUniqueId"] = this.fileUniqueId;
        if (Array.isArray(this.experiments)) {
            data["experiments"] = [];
            for (let item of this.experiments)
                data["experiments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICloneExperimentsPostModel {
    fileUniqueId: string;
    experiments?: CloneExperimentModel[] | undefined;
}

export class CloneExperimentModel implements ICloneExperimentModel {
    experimentId!: number;
    filterId!: number;
    filterVersionId!: number;

    constructor(data?: ICloneExperimentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.experimentId = _data["experimentId"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
        }
    }

    static fromJS(data: any): CloneExperimentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CloneExperimentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["experimentId"] = this.experimentId;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        return data;
    }
}

export interface ICloneExperimentModel {
    experimentId: number;
    filterId: number;
    filterVersionId: number;
}

export class GenerateExcelResponseModel implements IGenerateExcelResponseModel {
    requestId!: string;

    constructor(data?: IGenerateExcelResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): GenerateExcelResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateExcelResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IGenerateExcelResponseModel {
    requestId: string;
}

export class GenerateExcelRequestModel implements IGenerateExcelRequestModel {
    scenarioId!: number;
    filename!: string;
    parentDirectoryUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
    writeResults!: boolean;
    includeConvergedResults!: boolean;

    constructor(data?: IGenerateExcelRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.filename = _data["filename"];
            this.parentDirectoryUniqueId = _data["parentDirectoryUniqueId"];
            this.uploadConflictAction = _data["uploadConflictAction"];
            this.writeResults = _data["writeResults"];
            this.includeConvergedResults = _data["includeConvergedResults"];
        }
    }

    static fromJS(data: any): GenerateExcelRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateExcelRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["filename"] = this.filename;
        data["parentDirectoryUniqueId"] = this.parentDirectoryUniqueId;
        data["uploadConflictAction"] = this.uploadConflictAction;
        data["writeResults"] = this.writeResults;
        data["includeConvergedResults"] = this.includeConvergedResults;
        return data;
    }
}

export interface IGenerateExcelRequestModel {
    scenarioId: number;
    filename: string;
    parentDirectoryUniqueId?: string | undefined;
    uploadConflictAction?: UploadConflictAction | undefined;
    writeResults: boolean;
    includeConvergedResults: boolean;
}

export class ExportDataStatus implements IExportDataStatus {
    requestId!: string;
    filename?: string | undefined;
    filepath?: string | undefined;
    isGenerated!: boolean;

    constructor(data?: IExportDataStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.filename = _data["filename"];
            this.filepath = _data["filepath"];
            this.isGenerated = _data["isGenerated"];
        }
    }

    static fromJS(data: any): ExportDataStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExportDataStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["filename"] = this.filename;
        data["filepath"] = this.filepath;
        data["isGenerated"] = this.isGenerated;
        return data;
    }
}

export interface IExportDataStatus {
    requestId: string;
    filename?: string | undefined;
    filepath?: string | undefined;
    isGenerated: boolean;
}

export class ScenarioCountResultModel implements IScenarioCountResultModel {
    driveItemId?: string | undefined;
    count!: number;

    constructor(data?: IScenarioCountResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driveItemId = _data["driveItemId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ScenarioCountResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCountResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveItemId"] = this.driveItemId;
        data["count"] = this.count;
        return data;
    }
}

export interface IScenarioCountResultModel {
    driveItemId?: string | undefined;
    count: number;
}

export class ScenarioCountPostModel implements IScenarioCountPostModel {
    driveItemIds?: string[] | undefined;
    accessToken?: string | undefined;

    constructor(data?: IScenarioCountPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["driveItemIds"])) {
                this.driveItemIds = [] as any;
                for (let item of _data["driveItemIds"])
                    this.driveItemIds!.push(item);
            }
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): ScenarioCountPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCountPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.driveItemIds)) {
            data["driveItemIds"] = [];
            for (let item of this.driveItemIds)
                data["driveItemIds"].push(item);
        }
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IScenarioCountPostModel {
    driveItemIds?: string[] | undefined;
    accessToken?: string | undefined;
}

export class ScenarioProcessingQuery implements IScenarioProcessingQuery {
    accessToken!: string;
    scenarioId!: number;

    constructor(data?: IScenarioProcessingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.scenarioId = _data["scenarioId"];
        }
    }

    static fromJS(data: any): ScenarioProcessingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioProcessingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["scenarioId"] = this.scenarioId;
        return data;
    }
}

export interface IScenarioProcessingQuery {
    accessToken: string;
    scenarioId: number;
}

export class ResubmitFailedJobsPostModel implements IResubmitFailedJobsPostModel {
    accessToken!: string;
    scenarioId!: number;

    constructor(data?: IResubmitFailedJobsPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.scenarioId = _data["scenarioId"];
        }
    }

    static fromJS(data: any): ResubmitFailedJobsPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitFailedJobsPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["scenarioId"] = this.scenarioId;
        return data;
    }
}

export interface IResubmitFailedJobsPostModel {
    accessToken: string;
    scenarioId: number;
}

export class ScenariosListQuery implements IScenariosListQuery {
    driveItemId!: string;
    accessToken!: string;
    siteId!: string;
    flowsheetsListId!: string;

    constructor(data?: IScenariosListQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driveItemId = _data["driveItemId"];
            this.accessToken = _data["accessToken"];
            this.siteId = _data["siteId"];
            this.flowsheetsListId = _data["flowsheetsListId"];
        }
    }

    static fromJS(data: any): ScenariosListQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScenariosListQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driveItemId"] = this.driveItemId;
        data["accessToken"] = this.accessToken;
        data["siteId"] = this.siteId;
        data["flowsheetsListId"] = this.flowsheetsListId;
        return data;
    }
}

export interface IScenariosListQuery {
    driveItemId: string;
    accessToken: string;
    siteId: string;
    flowsheetsListId: string;
}

export class ScenarioListResponseModel implements IScenarioListResponseModel {
    totalRecords!: number;
    scenarios?: ScenarioResultModel[] | undefined;

    constructor(data?: IScenarioListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(ScenarioResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioListResponseModel {
    totalRecords: number;
    scenarios?: ScenarioResultModel[] | undefined;
}

export class ScenarioQuery implements IScenarioQuery {
    scenarioId!: number;
    driveItemId!: string;
    accessToken!: string;
    siteId!: string;
    flowsheetsListId!: string;

    constructor(data?: IScenarioQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.driveItemId = _data["driveItemId"];
            this.accessToken = _data["accessToken"];
            this.siteId = _data["siteId"];
            this.flowsheetsListId = _data["flowsheetsListId"];
        }
    }

    static fromJS(data: any): ScenarioQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["driveItemId"] = this.driveItemId;
        data["accessToken"] = this.accessToken;
        data["siteId"] = this.siteId;
        data["flowsheetsListId"] = this.flowsheetsListId;
        return data;
    }
}

export interface IScenarioQuery {
    scenarioId: number;
    driveItemId: string;
    accessToken: string;
    siteId: string;
    flowsheetsListId: string;
}

export class ReloadDataFromFileResultModel implements IReloadDataFromFileResultModel {
    requestId!: string;

    constructor(data?: IReloadDataFromFileResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): ReloadDataFromFileResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReloadDataFromFileResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IReloadDataFromFileResultModel {
    requestId: string;
}

export class ScenarioPostModel implements IScenarioPostModel {
    name!: string;
    sheet!: string;
    fileDriveId!: string;
    driveId!: string;
    fileVersion!: string;
    firstRow!: number;
    saveResultsToSourceFile!: boolean;
    calculationType!: CalculationType;
    stepEvaluationFunction?: string | undefined;
    filterId!: number;
    filterVersionId!: number;
    accessToken!: string;
    inputParameters?: ParameterModel2[] | undefined;
    outputParameters?: ParameterModel2[] | undefined;

    constructor(data?: IScenarioPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sheet = _data["sheet"];
            this.fileDriveId = _data["fileDriveId"];
            this.driveId = _data["driveId"];
            this.fileVersion = _data["fileVersion"];
            this.firstRow = _data["firstRow"];
            this.saveResultsToSourceFile = _data["saveResultsToSourceFile"];
            this.calculationType = _data["calculationType"];
            this.stepEvaluationFunction = _data["stepEvaluationFunction"];
            this.filterId = _data["filterId"];
            this.filterVersionId = _data["filterVersionId"];
            this.accessToken = _data["accessToken"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(ParameterModel2.fromJS(item));
            }
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(ParameterModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sheet"] = this.sheet;
        data["fileDriveId"] = this.fileDriveId;
        data["driveId"] = this.driveId;
        data["fileVersion"] = this.fileVersion;
        data["firstRow"] = this.firstRow;
        data["saveResultsToSourceFile"] = this.saveResultsToSourceFile;
        data["calculationType"] = this.calculationType;
        data["stepEvaluationFunction"] = this.stepEvaluationFunction;
        data["filterId"] = this.filterId;
        data["filterVersionId"] = this.filterVersionId;
        data["accessToken"] = this.accessToken;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioPostModel {
    name: string;
    sheet: string;
    fileDriveId: string;
    driveId: string;
    fileVersion: string;
    firstRow: number;
    saveResultsToSourceFile: boolean;
    calculationType: CalculationType;
    stepEvaluationFunction?: string | undefined;
    filterId: number;
    filterVersionId: number;
    accessToken: string;
    inputParameters?: ParameterModel2[] | undefined;
    outputParameters?: ParameterModel2[] | undefined;
}

export class ParameterModel2 implements IParameterModel2 {
    parameterId!: number;
    column?: string | undefined;

    constructor(data?: IParameterModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterId = _data["parameterId"];
            this.column = _data["column"];
        }
    }

    static fromJS(data: any): ParameterModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterId"] = this.parameterId;
        data["column"] = this.column;
        return data;
    }
}

export interface IParameterModel2 {
    parameterId: number;
    column?: string | undefined;
}

export class ScenarioDataResultModel implements IScenarioDataResultModel {
    totalRecords!: number;
    rows?: FileRowResultModel[] | undefined;

    constructor(data?: IScenarioDataResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(FileRowResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioDataResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioDataResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioDataResultModel {
    totalRecords: number;
    rows?: FileRowResultModel[] | undefined;
}

export class FileRowResultModel implements IFileRowResultModel {
    id!: number;
    scenarioId!: number;
    rowNum!: number;
    dispatcherJobId?: number | undefined;
    processingStatus!: RowProcessingStatus;
    cells?: FileCellResultModel[] | undefined;
    results?: FileRowResultResponseModel[] | undefined;

    constructor(data?: IFileRowResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scenarioId = _data["scenarioId"];
            this.rowNum = _data["rowNum"];
            this.dispatcherJobId = _data["dispatcherJobId"];
            this.processingStatus = _data["processingStatus"];
            if (Array.isArray(_data["cells"])) {
                this.cells = [] as any;
                for (let item of _data["cells"])
                    this.cells!.push(FileCellResultModel.fromJS(item));
            }
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(FileRowResultResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileRowResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileRowResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scenarioId"] = this.scenarioId;
        data["rowNum"] = this.rowNum;
        data["dispatcherJobId"] = this.dispatcherJobId;
        data["processingStatus"] = this.processingStatus;
        if (Array.isArray(this.cells)) {
            data["cells"] = [];
            for (let item of this.cells)
                data["cells"].push(item.toJSON());
        }
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileRowResultModel {
    id: number;
    scenarioId: number;
    rowNum: number;
    dispatcherJobId?: number | undefined;
    processingStatus: RowProcessingStatus;
    cells?: FileCellResultModel[] | undefined;
    results?: FileRowResultResponseModel[] | undefined;
}

export enum RowProcessingStatus {
    NotSubmittedToDispatcher = 0,
    SubmittedToDispatcher = 1,
    Calculated = 2,
    CalculationFailed = 3,
    ProcessingFailed = 4,
}

export class FileCellResultModel implements IFileCellResultModel {
    id!: number;
    filterParameterId!: number;
    value!: number;

    constructor(data?: IFileCellResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterParameterId = _data["filterParameterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FileCellResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileCellResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterParameterId"] = this.filterParameterId;
        data["value"] = this.value;
        return data;
    }
}

export interface IFileCellResultModel {
    id: number;
    filterParameterId: number;
    value: number;
}

export class FileRowResultResponseModel implements IFileRowResultResponseModel {
    id!: number;
    filterParameterId!: number;
    value!: number;

    constructor(data?: IFileRowResultResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.filterParameterId = _data["filterParameterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FileRowResultResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileRowResultResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["filterParameterId"] = this.filterParameterId;
        data["value"] = this.value;
        return data;
    }
}

export interface IFileRowResultResponseModel {
    id: number;
    filterParameterId: number;
    value: number;
}

export class ScenarioDataQuery implements IScenarioDataQuery {
    scenarioId!: number;
    driveItemId!: string;
    accessToken!: string;
    siteId!: string;
    flowsheetsListId!: string;
    rowNumber?: number | undefined;
    rowId?: number | undefined;
    applyPagination!: boolean;
    skip!: number;
    take!: number;

    constructor(data?: IScenarioDataQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.driveItemId = _data["driveItemId"];
            this.accessToken = _data["accessToken"];
            this.siteId = _data["siteId"];
            this.flowsheetsListId = _data["flowsheetsListId"];
            this.rowNumber = _data["rowNumber"];
            this.rowId = _data["rowId"];
            this.applyPagination = _data["applyPagination"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): ScenarioDataQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioDataQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["driveItemId"] = this.driveItemId;
        data["accessToken"] = this.accessToken;
        data["siteId"] = this.siteId;
        data["flowsheetsListId"] = this.flowsheetsListId;
        data["rowNumber"] = this.rowNumber;
        data["rowId"] = this.rowId;
        data["applyPagination"] = this.applyPagination;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IScenarioDataQuery {
    scenarioId: number;
    driveItemId: string;
    accessToken: string;
    siteId: string;
    flowsheetsListId: string;
    rowNumber?: number | undefined;
    rowId?: number | undefined;
    applyPagination: boolean;
    skip: number;
    take: number;
}

export class SenarioDataElasticQuery implements ISenarioDataElasticQuery {
    scenarioId!: number;
    processingStatus?: RowProcessingStatus | undefined;
    parameterFilter?: ParameterFilter | undefined;
    rowId?: number | undefined;
    rowNumber?: number | undefined;
    dispatcherJobId?: number | undefined;
    orderBy?: string | undefined;
    orderByDescending!: boolean;
    skip!: number;
    take!: number;

    constructor(data?: ISenarioDataElasticQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.processingStatus = _data["processingStatus"];
            this.parameterFilter = _data["parameterFilter"] ? ParameterFilter.fromJS(_data["parameterFilter"]) : <any>undefined;
            this.rowId = _data["rowId"];
            this.rowNumber = _data["rowNumber"];
            this.dispatcherJobId = _data["dispatcherJobId"];
            this.orderBy = _data["orderBy"];
            this.orderByDescending = _data["orderByDescending"];
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): SenarioDataElasticQuery {
        data = typeof data === 'object' ? data : {};
        let result = new SenarioDataElasticQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["processingStatus"] = this.processingStatus;
        data["parameterFilter"] = this.parameterFilter ? this.parameterFilter.toJSON() : <any>undefined;
        data["rowId"] = this.rowId;
        data["rowNumber"] = this.rowNumber;
        data["dispatcherJobId"] = this.dispatcherJobId;
        data["orderBy"] = this.orderBy;
        data["orderByDescending"] = this.orderByDescending;
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface ISenarioDataElasticQuery {
    scenarioId: number;
    processingStatus?: RowProcessingStatus | undefined;
    parameterFilter?: ParameterFilter | undefined;
    rowId?: number | undefined;
    rowNumber?: number | undefined;
    dispatcherJobId?: number | undefined;
    orderBy?: string | undefined;
    orderByDescending: boolean;
    skip: number;
    take: number;
}

export class ParameterFilter implements IParameterFilter {
    parameterId?: string | undefined;
    filterOperation!: FilterOperation;
    equalsValue?: number | undefined;
    endsValue?: number | undefined;

    constructor(data?: IParameterFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterId = _data["parameterId"];
            this.filterOperation = _data["filterOperation"];
            this.equalsValue = _data["equalsValue"];
            this.endsValue = _data["endsValue"];
        }
    }

    static fromJS(data: any): ParameterFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterId"] = this.parameterId;
        data["filterOperation"] = this.filterOperation;
        data["equalsValue"] = this.equalsValue;
        data["endsValue"] = this.endsValue;
        return data;
    }
}

export interface IParameterFilter {
    parameterId?: string | undefined;
    filterOperation: FilterOperation;
    equalsValue?: number | undefined;
    endsValue?: number | undefined;
}

export enum FilterOperation {
    Equals = 0,
    Between = 1,
}

export class DeleteScenarioPostModel implements IDeleteScenarioPostModel {
    scenarioId!: number;
    accessToken!: string;

    constructor(data?: IDeleteScenarioPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): DeleteScenarioPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScenarioPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IDeleteScenarioPostModel {
    scenarioId: number;
    accessToken: string;
}

export class WriteResultsResponseModel implements IWriteResultsResponseModel {
    requestId!: string;

    constructor(data?: IWriteResultsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): WriteResultsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WriteResultsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IWriteResultsResponseModel {
    requestId: string;
}

export class ScenarioWriteResultsQuery implements IScenarioWriteResultsQuery {
    scenarioId!: number;
    accessToken!: string;
    writeIds!: boolean;
    filename?: string | undefined;
    writeDataTo!: WriteDataTo;

    constructor(data?: IScenarioWriteResultsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.accessToken = _data["accessToken"];
            this.writeIds = _data["writeIds"];
            this.filename = _data["filename"];
            this.writeDataTo = _data["writeDataTo"];
        }
    }

    static fromJS(data: any): ScenarioWriteResultsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioWriteResultsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["accessToken"] = this.accessToken;
        data["writeIds"] = this.writeIds;
        data["filename"] = this.filename;
        data["writeDataTo"] = this.writeDataTo;
        return data;
    }
}

export interface IScenarioWriteResultsQuery {
    scenarioId: number;
    accessToken: string;
    writeIds: boolean;
    filename?: string | undefined;
    writeDataTo: WriteDataTo;
}

export enum WriteDataTo {
    CurrentAsOverwrite = 0,
    CurrentAsNewFile = 1,
    HistoricVersionAsNewFile = 2,
}

export class UpdateDataFromFileStatusModel implements IUpdateDataFromFileStatusModel {
    requestId!: string;
    finishedRows!: number;
    status!: UpdateDataFromFileStatus;
    isError!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IUpdateDataFromFileStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.finishedRows = _data["finishedRows"];
            this.status = _data["status"];
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): UpdateDataFromFileStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDataFromFileStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["finishedRows"] = this.finishedRows;
        data["status"] = this.status;
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IUpdateDataFromFileStatusModel {
    requestId: string;
    finishedRows: number;
    status: UpdateDataFromFileStatus;
    isError: boolean;
    errorMessage?: string | undefined;
}

export enum UpdateDataFromFileStatus {
    InQueue = 0,
    InProgress = 1,
    Finished = 2,
    Failed = 3,
}

export class WriteResultsStatusModel implements IWriteResultsStatusModel {
    requestId!: string;
    filename?: string | undefined;
    filepath?: string | undefined;
    status!: WriteResultsStatus;
    isError!: boolean;
    errorMessage?: string | undefined;

    constructor(data?: IWriteResultsStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.filename = _data["filename"];
            this.filepath = _data["filepath"];
            this.status = _data["status"];
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): WriteResultsStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new WriteResultsStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["filename"] = this.filename;
        data["filepath"] = this.filepath;
        data["status"] = this.status;
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IWriteResultsStatusModel {
    requestId: string;
    filename?: string | undefined;
    filepath?: string | undefined;
    status: WriteResultsStatus;
    isError: boolean;
    errorMessage?: string | undefined;
}

export enum WriteResultsStatus {
    InQueue = 0,
    InProgress = 1,
    Finished = 2,
    Failed = 3,
}

export class ResubmitRowPostModel implements IResubmitRowPostModel {
    accessToken!: string;
    scenarioId!: number;
    rowId!: number;

    constructor(data?: IResubmitRowPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.scenarioId = _data["scenarioId"];
            this.rowId = _data["rowId"];
        }
    }

    static fromJS(data: any): ResubmitRowPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResubmitRowPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["scenarioId"] = this.scenarioId;
        data["rowId"] = this.rowId;
        return data;
    }
}

export interface IResubmitRowPostModel {
    accessToken: string;
    scenarioId: number;
    rowId: number;
}

export class ReindexingRunModel implements IReindexingRunModel {
    uniqueId!: string;
    type?: string | undefined;
    batchSize!: number;
    totalItemsCount!: number;
    startedAt!: Date;
    status!: RunningStatus;
    message?: string | undefined;
    lastProcessedId?: number | undefined;
    processedItemsCount!: number;
    processedPercentage?: number | undefined;
    overallAverageDurationPerIteration!: number;
    sqlAverageDurationPerIteration!: number;
    indexAverageDurationPerIteration!: number;
    timeLeftStr?: string | undefined;

    constructor(data?: IReindexingRunModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.type = _data["type"];
            this.batchSize = _data["batchSize"];
            this.totalItemsCount = _data["totalItemsCount"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            this.lastProcessedId = _data["lastProcessedId"];
            this.processedItemsCount = _data["processedItemsCount"];
            this.processedPercentage = _data["processedPercentage"];
            this.overallAverageDurationPerIteration = _data["overallAverageDurationPerIteration"];
            this.sqlAverageDurationPerIteration = _data["sqlAverageDurationPerIteration"];
            this.indexAverageDurationPerIteration = _data["indexAverageDurationPerIteration"];
            this.timeLeftStr = _data["timeLeftStr"];
        }
    }

    static fromJS(data: any): ReindexingRunModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReindexingRunModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["type"] = this.type;
        data["batchSize"] = this.batchSize;
        data["totalItemsCount"] = this.totalItemsCount;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        data["lastProcessedId"] = this.lastProcessedId;
        data["processedItemsCount"] = this.processedItemsCount;
        data["processedPercentage"] = this.processedPercentage;
        data["overallAverageDurationPerIteration"] = this.overallAverageDurationPerIteration;
        data["sqlAverageDurationPerIteration"] = this.sqlAverageDurationPerIteration;
        data["indexAverageDurationPerIteration"] = this.indexAverageDurationPerIteration;
        data["timeLeftStr"] = this.timeLeftStr;
        return data;
    }
}

export interface IReindexingRunModel {
    uniqueId: string;
    type?: string | undefined;
    batchSize: number;
    totalItemsCount: number;
    startedAt: Date;
    status: RunningStatus;
    message?: string | undefined;
    lastProcessedId?: number | undefined;
    processedItemsCount: number;
    processedPercentage?: number | undefined;
    overallAverageDurationPerIteration: number;
    sqlAverageDurationPerIteration: number;
    indexAverageDurationPerIteration: number;
    timeLeftStr?: string | undefined;
}

export enum RunningStatus {
    Running = 0,
    Finished = 1,
    Failed = 2,
}

export class ServiceInformationModel implements IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;

    constructor(data?: IServiceInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildDate = _data["buildDate"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ServiceInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildDate"] = this.buildDate;
        data["version"] = this.version;
        return data;
    }
}

export interface IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}